var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.335,
    height: 22.438,
    viewBox: "0 0 17.335 22.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M12.8.375V2.428H1.84V16.7H0V2.428A2.1,2.1,0,0,1,.535.971,1.686,1.686,0,0,1,1.84.375H12.8Zm2.739,4.106a1.644,1.644,0,0,1,1.262.6,2.044,2.044,0,0,1,.535,1.408V20.76a2.1,2.1,0,0,1-.535,1.456,1.643,1.643,0,0,1-1.262.6H5.479a1.688,1.688,0,0,1-1.306-.6,2.1,2.1,0,0,1-.535-1.456V6.486a2.039,2.039,0,0,1,.535-1.408,1.691,1.691,0,0,1,1.305-.6H15.537Zm0,16.279V6.486H5.479V20.76H15.537Z",
    transform: "translate(0 -0.375)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c081525c.svg";
export { ForwardRef as ReactComponent };